import React from 'react';

interface EventContextProps {
    eventId?: string;
}

export const EventContext = React.createContext<Partial<EventContextProps>>({});
